export { default } from './BingAdsScripts';
